import Vue from "vue";
import VueI18n from "vue-i18n";
import axios from "./axios";
import { get } from "lodash";
import store from "./store/store";

Vue.use(VueI18n);

export const getLocale = () => {
  const currentLocale = localStorage.getItem("locale");
  if (currentLocale) {
    return currentLocale;
  }
  let userLang =
    navigator.language ||
    get(navigator.userLanguage, process.env.VUE_APP_I18N_LOCALE);
  userLang = userLang.split("-")[0];
  const permittedLocale = store.state.campaign.accept_languages; //TODO prendere da api
  let toBeReturnedLang = null;
  if (permittedLocale && permittedLocale.includes(userLang)) {
    toBeReturnedLang = userLang || process.env.VUE_APP_I18N_LOCALE || "it";
  } else {
    toBeReturnedLang = "it";
  }
  return toBeReturnedLang;
};

// const missingHandler = (locale, key) => {
//   const env = process.env.VUE_APP_ENV || "production";

//   if (env == "production") {
//     axios.post("/api/v1/translations ", { locale: locale, key: key });
//   }
// };
const locale = getLocale();
if (locale) {
  localStorage.setItem("locale", locale);
}
store.commit("updateUserLocale", locale);

const i18n = new VueI18n({
  locale: locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "it"
});

// export function loadLocaleMessages() {
//   const locales = require.context(
//     "./locales",
//     true,
//     /[A-Za-z0-9-_,\s]+\.json$/i
//   );
//   const messages = {};
//   locales.keys().forEach(key => {
//     const matched = key.match(/([A-Za-z0-9-_]+)\./i);
//     if (matched && matched.length > 1) {
//       const locale = matched[1];
//       messages[locale] = locales(key);
//     }
//   });
//   return messages;
// }

export async function loadLocaleMessagesfromApi(locale) {
  let messages = {};
  messages[locale] = {};
  let translations = {};
  try {
    axios.defaults.headers["Accept-Language"] = locale;
    const response = await axios.get(`/api/v1/campaign/translations`);
    translations = get(response, "data.data", {});

    messages[locale] = translations;
  } catch (error) {
    console.log(error);
  }

  return messages;
}

export async function changeLocale(locale, reload = true) {
  const localeResponse = loadLocaleMessagesfromApi(locale);

  i18n.setLocaleMessage(locale, localeResponse[locale]);
  i18n.locale = locale;
  store.commit("updateUserLocale", locale);
  localStorage.setItem("locale", locale);
  reload && window.location.reload();
}

export default i18n;
